export class BaseLocalRepository {
  constructor(db, tableName) {
    this.db = db;
    this.table = db.table(tableName);
  }

  async getById(id) {
    return this.table.get(id);
  }

  async put(record) {
    await this.table.put(record);
    return record;
  }

  async bulkPut(records) {
    await this.table.bulkPut(records);
    return records;
  }

  async delete(id) {
    await this.table.delete(id);
  }

  async listAll() {
    return this.table.toArray();
  }
}
